<div class="container">
  <div class="row">
    <div class="col-12">
      <h2>Unsubscribed</h2>
      <p>We will no longer send emails to your e-mail address. Thank you!</p>
    </div>
  </div>
</div>